<template>
  <div class="index">
    <div class="information-container">
      <div class="disclosure-information-wrapper">
        <Editor v-if="settingsData"
        :editorToolbar="customToolbar"
        placeholder="Текст информации"
        v-model="text"/>
      </div>
      <div class="save-content-button centered">
        <button class="button save-content" @click="handleSaveDisclosureInformation()" :disabled="disabled">{{ disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ' }}</button>
      </div>
      <draggable v-model="documentsData" class="columns is-multiline documents" v-if="documentsData">
        <DisclosureItem v-for="document in documentsData" :document="document" :key="document.id"/>
      </draggable>
      <div class="centered add-document">
        <span class="button-wrapper link" @click="handleAddDisclosureInformation">
          <a class="button is-info">+</a> Добавить информацию
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DisclosureItem from 'components/Information/DisclosureItem'
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import draggable from 'vuedraggable'
import { VueEditor as Editor } from 'vue2-editor'
import uuidv4 from 'uuid/v4'

export default {
  name: 'InformationDocuments',
  data () {
    return {
      disabled: false,
      customToolbar: [
        ['bold', 'italic', 'underline'],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        ['link', 'image'],
        [{ 'align': [] }]
      ],
      text: ''
    }
  },
  computed: {
    ...mapState(['disclosureInformation', 'settings']),
    documentsData: {
      get () {
        return deepcopy(this.disclosureInformation)
      },
      set (val) {
        for (let i = 0; i < val.length; i++) {
          val[i].order = i
        }
        this.updateAllDisclosureDocuments(val)
      }
    },
    settingsData () {
      if (this.settings) {
        this.text = this.settings.requisitesInformation
        return deepcopy(this.settings)
      } else {
        return null
      }
    }
  },
  created () {
    this.getSettings()
    this.getDisclosureInformation()
  },
  methods: {
    ...mapActions(['getDisclosureInformation',
      'addDisclosureInformation', 'updateAllDisclosureDocuments',
      'getSettings', 'saveSettings', 'saveDisclosureInformation']),
    handleAddDisclosureInformation () {
      this.addDisclosureInformation({
        id: uuidv4(),
        showType: 'document'
      })
    },
    handleSaveDisclosureInformation () {
      this.disabled = true
      this.saveDisclosureInformation(this.disclosureInformation)
      .then(() => {
        return this.saveSettings(this.settingsData)
      })
      .then(() => {
        this.disabled = false
        this.$toast.open({ message: 'Сохранено' })
      })
    }
  },
  watch: {
    text (val) {
      this.settingsData.requisitesInformation = val
    }
  },
  components: { DisclosureItem, draggable, Editor }
}
</script>

<style scoped>
.information-container {
  padding: 25px 90px 60px;
  margin: 15px 0 0;
  max-width: 1368px;
  margin: 0 auto;
}
.documents {
  margin-top: 25px;
}
.disclosure-information-wrapper {
  max-width: 620px;
  margin: 0 auto 20px;
}
.save-content {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// Disclosure.vue?53a87de4